import CommonHeadings from "helper/constant/headings";
import Dateformat from "helper/constant/timeFormat";
import React, { useEffect, useLayoutEffect, useState } from "react";
import Moment from "react-moment";
import { useLocation } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { query, collection, orderBy, getDocs, where, Timestamp } from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import TableName from "helper/tableName/tableName";
import { Calendar } from "primereact/calendar";
import moment from "moment";

function StudentsAttedanceView() {
  const [studentData, setStudentData] = useState([]);
  const [dates, setDates] = useState(new Date());
  const location = useLocation();

  // MARK: Use Layout Method
  useLayoutEffect(() => {
    document.title = CommonHeadings.studentView;
  }, []);

  useEffect(() => {
    const date = new Date();
    findMonthStartandEnd(date);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const inputChange = (e) => {
    const date = e.value;

    setDates(date);

    findMonthStartandEnd(date);
  };

  function findMonthStartandEnd(date) {
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    const momentStartDate = moment(new Date(firstDay)).format("YYYY-MM-DD");
    const momentEndDate = moment(new Date(lastDay)).format("YYYY-MM-DD");

    const startTimestamp = Timestamp.fromDate(new Date(momentStartDate)).toMillis();
    const endTimestamp = Timestamp.fromDate(new Date(momentEndDate)).toMillis();
    fetchStudentsAttendanceApi(startTimestamp, endTimestamp);
  }
  

  //MARK: Student Name
  const studentName = () => {
    return (
      <>
        <div>
          <p className="table__column__capital">Student Name: {location.state.name}</p>
        </div>

      </>
    );
  };

  const header = studentName();

  // MARK: demo students columns data
  const studentsColumns = [
    {
      field: "date",
      header: "Date",
      CardBody: (studentModal) => (
        <Moment format={Dateformat.DDMMYYYY}>{studentModal.date}</Moment>
      ),
    },
  ];

  // MARK: fetch student attendance data
  async function fetchStudentsAttendanceApi(startDate, endDate) {
    const id = location.state.id;

    let q = query(
      collection(dbFirestore, TableName.attendance),
      where("date", ">=", startDate), where("date", "<=", endDate),
      where("attendance", "array-contains", id),
      orderBy("created_at", "desc")
    );
    const querySnapshot = await getDocs(q);

    const array = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
    }));

    setStudentData(array);
  }

  return (
    <div className="modules__main__div mt-5">
      <div className="col-12">
        <div className="card modules__card">
          <div className="mt-3 mb-5">
            <Calendar
              value={dates}
              onChange={inputChange}
              view="month"
              dateFormat="MM, yy"
              showIcon
              placeholder="mm/yyyy"
            />
          </div>
          <DataTable
            className="mb-3"
            value={studentData} header={header}
            emptyMessage="No data found."
          >
            {studentsColumns.map((col) => (
              <Column
                key={col.field}
                field={col.field}
                header={col.header}
                bodyClassName={col.className}
                body={col.CardBody}
              />
            ))}

            {studentData && (
              <Column field="status" header="Status" body="Present"></Column>
            )}
          </DataTable>
        </div>
      </div>
    </div>
  );
}

export default StudentsAttedanceView;
